import { ITableOfTableItem } from "../../../../../modules/API/Defaults/models/tableOfTables";
import { IOrderItem } from "../../../../../modules/API/Drivers/models/kavData";

export type DeliveryActionVariant = "accent" | "danger";

export interface IDeliveryActionButton {
  code: number;
  label: string;
  variant: DeliveryActionVariant;
}

export type OrderDeliveryState = "delivered" | "failed" | "none";

export const getDeliveryActionButtons = (
  list: ITableOfTableItem[] | undefined
): IDeliveryActionButton[] => {
  // SecondCode 0 — служебная строка таблицы, кнопкой не бывает.
  return (list ?? [])
    .filter((status) => status.SecondCode !== 0)
    .map((status) => ({
      code: status.SecondCode,
      label: status.Description.trim(),
      variant: status.Flag ? "accent" : "danger",
    }));
};

export const hasSelectedOrders = (orders: IOrderItem[] | undefined): boolean => {
  return !!orders?.some((order) => order.Selected);
};

export const getOrderDeliveryState = (
  order: Pick<IOrderItem, "LastAction">
): OrderDeliveryState => {
  const action = order.LastAction?.Action;
  if (action === 1) return "delivered";
  if (action > 1) return "failed";
  return "none";
};

export const getSelectedOrders = (orders: IOrderItem[] | undefined): IOrderItem[] => {
  return (orders ?? []).filter((order) => order.Selected);
};
